/**
 * Version info generated from git at build/serve time.
 * Do not edit manually; run `npm run generate-version` or rely on start/build hooks.
 */
export const versionInfo = {
  commitId: '82fbe65c1717418084050611331bf5470af1a71e',
  gitTag: '',
  branch: 'enkash_uat',
  commitDateTime: '2026-11-04T02:22:50+05:30',
  commitMessage: 'Merge branch \'PI-5155-autodebit-to-ops-users\' into enkash_uat',
  buildTime: '11/4/2026, 10:56:58 AM'
};
